import { styled, blurBehindMixin } from "../../../styled-components";
import { css } from "styled-components";
import { mobileSystemFontFamily } from "../../../lib/theme/theme";

const androidWrapperStyle = css`
    text-align: start;
`;

const iOSWrapperStyle = css`
    text-align: center;
`;

export const NavBarFabWrapper = styled.div`
    position: absolute;
    width: 100%;
    right: 0;
    bottom: var(--safe-area-inset-bottom);
`;

export const TitleStyle = styled.h1<{ opacity: number }>`
    flex-grow: 1;

    ${p => (p.theme.navBar.style === "Android" ? androidWrapperStyle : iOSWrapperStyle)}
    ${p => p.theme.navBar.titleFontStyle};
    color: ${p => p.theme.navBar.titleColor};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    opacity: ${p => p.opacity};

    transition: opacity 0.2s;
`;

export const NavBarStyle = styled.div`
    color: ${p => p.theme.navBar.fgColor};
    height: ${p => p.theme.navBar.height}px;

    font: ${mobileSystemFontFamily};

    flex-shrink: 0;
    display: flex;
    position: relative;
    align-items: center;
`;

const disabledProps = css`
    opacity: 0.4;
    pointer-events: none;
`;

export const NavBarButtonWrapper = styled.button<{ setFill: boolean; enabled: boolean; bold?: boolean }>`
    height: ${p => p.theme.navBar.height}px;

    padding: 0 16px;
    margin: 0;
    border: none;

    ${p => p.theme.fontStyles.Body4}
    color: inherit;

    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    ${p => p.bold === true && `font-weight: 600;`}

    ${p => !p.enabled && disabledProps}

    &:hover {
        cursor: pointer;
    }

    ${p =>
        p.setFill &&
        `svg {
        fill: ${p.theme.navBar.fgColor};
    }`}
`;

export const BackText = styled.div`
    ${p => p.theme.fontStyles.Header4Fixed}
    padding-left: 7px;
`;

export const RightButtonsWrapper = styled.div`
    display: grid;
    flex-shrink: 100000;

    & > * {
        justify-self: end;
        grid-column: 1;
        grid-row: 1;
    }
`;

export const MarginSpacer = styled.div`
    width: ${p => p.theme.pageMarginMedium}px;
`;

export const RightButtonsInner = styled.div`
    display: flex;
    z-index: 100;

    & > * + * {
        margin-left: -12px;
    }
`;

export const LeftButtonsWrapper = styled.div`
    display: grid;
    /* Hello dear reader. I am sure you are looking at this z-index thinking I am a moron.
       While true, in this case there is more to the story. Safari will clip this bad boy
       for no good reason because it thinks it is occluded by a hidden element. Safari be
       dumb as shit. */
    z-index: 100;
    flex-shrink: 100000;

    & > * {
        justify-self: start;
        grid-column: 1;
        grid-row: 1;
    }
`;

export const ModalNavOuter = styled.div`
    background-color: ${p => p.theme.baseColor};

    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
`;

export const ModalNavWrapper = styled.div`
    background-color: ${p => p.theme.navBar.bgColor};
    border-radius: ${p => p.theme.navBar.borderRadius}px ${p => p.theme.navBar.borderRadius}px 0px 0px;

    ${p =>
        blurBehindMixin({
            backgroundColor: p.theme.navBar.transparentBgColor,
            fadeTo: p.theme.navBar.fadeTo,
        })};
`;

export const ShadowItem = styled.div`
    visibility: hidden;
    pointer-events: none;
    opacity: 0;
    min-width: 1px;
`;
